// api
import request from '@/tool/request'

const c = 'TaskSpongeman/';

/****************************** 后台首页 ******************************/
// 后台首页数据
export function index(query) {
  return request({
    url: c+'index',
    method: 'post',
    data:query
  })
}
// 获取站内信未读数量
export function znxNoRead(query) {
  return request({
    url: c+'znxNoRead',
    method: 'post',
    data:query
  })
}

/****************************** 任务 ******************************/
// 任务
export function taskList(query) {
  return request({
    url: c+'taskList',
    method: 'post',
    data:query
  })
}
// 任务详情
export function taskDetails(query) {
  return request({
    url: c+'taskDetails',
    method: 'post',
    data:query
  })
}
// 任务领取
export function taskDraw(query) {
  return request({
    url: c+'taskDraw',
    method: 'post',
    data:query
  })
}

/****************************** 订单 ******************************/
// 获取列表的其他数据
export function orderListInit(query) {
  return request({
    url: c+'orderListInit',
    method: 'post',
    data:query
  })
}
// 列表
export function orderList(query) {
  return request({
    url: c+'orderList',
    method: 'post',
    data:query
  })
}
// 下单
export function orderBuy(query) {
  return request({
    url: c+'orderBuy',
    method: 'post',
    data:query
  })
}
// 确认收货
export function orderSh(query) {
  return request({
    url: c+'orderSh',
    method: 'post',
    data:query
  })
}
// 评论
export function pl(query) {
  return request({
    url: c+'pl',
    method: 'post',
    data:query
  })
}
// 取消订单
export function orderCancel(query) {
  return request({
    url: c+'orderCancel',
    method: 'post',
    data:query
  })
}
// 订单投诉
export function orderComplain(query) {
  return request({
    url: c+'orderComplain',
    method: 'post',
    data:query
  })
}

/****************************** 投诉列表 ******************************/
// 列表页的其他数据
export function complainListInit(query) {
  return request({
    url: c+'complainListInit',
    method: 'post',
    data:query
  })
}
// 投诉列表
export function complainList(query) {
  return request({
    url: c+'complainList',
    method: 'post',
    data:query
  })
}

/****************************** 佣金记录 ******************************/
// 列表
export function commissionList(query) {
  return request({
    url: c+'commissionList',
    method: 'post',
    data:query
  })
}

/****************************** 资金管理 ******************************/
// 资金明细的其他数据
export function brListInit(query) {
  return request({
    url: c+'brListInit',
    method: 'post',
    data:query
  })
}
// 资金明细
export function brList(query) {
  return request({
    url: c+'brList',
    method: 'post',
    data:query
  })
}

/****************************** 账户设置 ******************************/
// 列表
export function accountList(query) {
  return request({
    url: c+'accountList',
    method: 'post',
    data:query
  })
}
// 设置
export function accountSet(query) {
  return request({
    url: c+'accountSet',
    method: 'post',
    data:query
  })
}
// 删除
export function accountDel(query) {
  return request({
    url: c+'accountDel',
    method: 'post',
    data:query
  })
}

/****************************** 提现 ******************************/
// 提现的其他数据
export function withdrawalInit(query) {
  return request({
    url: c+'withdrawalInit',
    method: 'post',
    data:query
  })
}
// 提现
export function withdrawal(query) {
  return request({
    url: c+'withdrawal',
    method: 'post',
    data:query
  })
}
// 提现列表
export function withdrawalList(query) {
  return request({
    url: c+'withdrawalList',
    method: 'post',
    data:query
  })
}

/****************************** 基本信息 ******************************/
// 获取
export function userIndex(query) {
  return request({
    url: c+'userIndex',
    method: 'post',
    data:query
  })
}
// 设置
export function setUserIndex(query) {
  return request({
    url: c+'setUserIndex',
    method: 'post',
    data:query
  })
}

/****************************** 账户安全 ******************************/
// 修改密码
export function changePwd(query) {
  return request({
    url: c+'changePwd',
    method: 'post',
    data:query
  })
}

/****************************** 站内信 ******************************/
// 列表
export function msgList(query) {
  return request({
    url: c+'msgList',
    method: 'post',
    data:query
  })
}
// 已读
export function msgRead(query) {
  return request({
    url: c+'msgRead',
    method: 'post',
    data:query
  })
}

/****************************** 退出登录 ******************************/
// 退出登录
export function logout(query) {
  return request({
    url: c+'logout',
    method: 'post',
    data:query
  })
}

// 视频下载token
export function downloadToken(query) {
  return request({
    url: c+'downloadToken',
    method: 'post',
    data:query
  })
}
